import { useState, useEffect } from 'react';
// @form
import { Label, TextFields, MultipleFields, SelectFields, Message } from 'components/hook-form';
// utils
import { REGEXP_DECIMAL } from 'utils/regexp';

// ----------------------------------------------------------------------

const options = [
  {value: 'OUT_OF_RANGE', name: '범위'},
  {value: 'LOWER_LIMIT', name: '하한'},
  {value: 'UPPER_LIMIT', name: '상한'},
  {value: 'OFF', name: '알람 정지'}
];

export default function MultipleField({ value: values, data, setData }: { value: any, data: any, setData: any }) {

  const [ value, setValue ] = useState(values);

  const [ errorAlarmLowerLimit, setErrorAlarmLowerLimit ] = useState(false);
  const [ errorAlarmUpperLimit, setErrorAlarmUpperLimit ] = useState(false);
  const [ message, setMessage ] = useState(null);

  useEffect(() => {
    if ( (value.alarmType === 'OUT_OF_RANGE' || value.alarmType === 'LOWER_LIMIT') && value.alarmLowerLimit !== null && !REGEXP_DECIMAL.test(String(value.alarmLowerLimit)) ) {
      setErrorAlarmLowerLimit(false);
    } else {
      setErrorAlarmLowerLimit(true);
    }
    if ( (value.alarmType === 'OUT_OF_RANGE' || value.alarmType === 'UPPER_LIMIT') && value.alarmUpperLimit !== null && !REGEXP_DECIMAL.test(String(value.alarmUpperLimit)) ) {
      setErrorAlarmUpperLimit(false);
    } else {
      setErrorAlarmUpperLimit(true);
    }

    if ( !value.error && value.alarmType === 'OUT_OF_RANGE' && value.alarmLowerLimit !== null && value.alarmUpperLimit !== null && value.alarmLowerLimit >= value.alarmUpperLimit ) {
      setMessage('범위 설정을 확인해 주세요.');
      setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], error: true }} });
    } else if ( message === '범위 설정을 확인해 주세요.' && value.alarmType !== 'OUT_OF_RANGE' || (value.alarmType === 'OUT_OF_RANGE' && value.alarmLowerLimit < value.alarmUpperLimit) ) {
      setMessage(null);
      setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], error: false }} });
    }

    if ( value.alarmType === 'OUT_OF_RANGE' ) {
      if ( value.alarmLowerLimit === null && value.alarmUpperLimit === null ) {
        setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmLowerLimit: 0, alarmUpperLimit: 1 }} });
        setValue({ ...value, alarmLowerLimit: 0, alarmUpperLimit: 1 });
      } else if ( value.alarmLowerLimit === null ) {
        setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmLowerLimit: 0 }} });
        setValue({ ...value, alarmLowerLimit: 0 });
      } else if ( value.alarmUpperLimit === null ) {
        setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmUpperLimit: 1 }} });
        setValue({ ...value, alarmUpperLimit: 1 });
      }
    }

    if ( value.alarmType === 'LOWER_LIMIT' && value.alarmLowerLimit === null ) {
      setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmLowerLimit: 0 }} });
      setValue({ ...value, alarmLowerLimit: 0 });
    }

    if ( value.alarmType === 'UPPER_LIMIT' && value.alarmUpperLimit === null ) {
      setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmUpperLimit: 0 }} });
      setValue({ ...value, alarmUpperLimit: 0 });
    }
  }, [value]);

  useEffect(() => {
    if ( !errorAlarmLowerLimit || !errorAlarmUpperLimit ) {
      setMessage('숫자, 소수점 3자리까지만 입력해 주세요.');
      setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], error: true }} });
    } else {
      setMessage(null);
      setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], error: false }} });
    }
  }, [errorAlarmLowerLimit, errorAlarmUpperLimit]);

  return (
    <div>
      <Label>{ value.name } <span style={{'color': '#4D5E80', 'fontSize': '12px'}}>({ value.unit })</span></Label>
      <MultipleFields>
        <div>
          <SelectFields $error={false} value={value.alarmType} onChange={(event) => {
            setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmType: event.target.value }} });
            setValue({ ...value, alarmType: event.target.value });
          }}>
            { options.map((option) => (
              <option key={option.value} value={option.value}>
                { option.name }
              </option>
            ))}
          </SelectFields>
        </div>
        <div>
          <div>
            <TextFields type='number' step={0.1} value={value.alarmLowerLimit ? value.alarmLowerLimit : 0} onChange={(event) => {
              setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmLowerLimit: event.target.value }} });
              setValue({ ...value, alarmLowerLimit: event.target.value });
            }} $error={errorAlarmLowerLimit ? false : true} disabled={ value.alarmType === 'UPPER_LIMIT' || value.alarmType === 'OFF' ? true : false } />
          </div>
          <p>~</p>
          <div>
            <TextFields type='number' step={0.1} value={value.alarmUpperLimit ? value.alarmUpperLimit : 1} onChange={(event) => {
              setData({ ...data, [value.type]: { ...data[value.type], [value.id]: { ...data[value.type][value.id], alarmUpperLimit: event.target.value }} });
              setValue({ ...value, alarmUpperLimit: event.target.value });
            }} $error={errorAlarmUpperLimit ? false : true} disabled={ value.alarmType === 'LOWER_LIMIT' || value.alarmType === 'OFF' ? true : false } />
          </div>
        </div>
      </MultipleFields>
      { message &&
        <Message>{ message }</Message>
      }
    </div>
  );
};